import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ocb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(e) {
  if (e?.code === "ECONNABORTED" || e?.message?.includes("timeout")) {
    return "The shop office is taking too long to answer — check your internet connection and try again.";
  }
  if (e?.message === "Network Error") {
    return "No connection to the shop office — check your internet, fully refresh the page, and try again.";
  }
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || String(x)).join(" ");
  return String(detail);
}
